export default __webpack_public_path__ + "static/media/Air-Purifiers-Category-Offer.59245d03.png";